import * as actionTypes from "./actionTypes";
import {
  getIssueSummaryApi,
  getIssueSummaryMatrixApi,
} from "@icarius-connection/api";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString, getErrorStringFromServerError } from "@icarius-localization/strings";

const errorHandler = (e, dispatch) => {
  let errorString = "";
  switch (e.response?.data?.status) {
    case "INVALID_DATA":
      errorString = getLocalizedString("validationError");
      break;
    default:
      errorString = getErrorStringFromServerError(e);
      break;
  }
  dispatch(openSnackbarAction({ msg: errorString, severity: "error" }));
}

export const getIssueSummaryAction = (code) => async (dispatch) => {
  dispatch({ type: actionTypes.GET });
  try {
    let response = await getIssueSummaryApi(code ? `?code=${code}` : '');
    let data = response.data && response.data.data;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_FULFILLED,
      payload: { data },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

export const getIssueSummaryMatrixAction = (code) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_MATRIX });
  try {
    let response = await getIssueSummaryMatrixApi(`?code=${code}`);
    let data = response.data && response.data.data;
    let yearList = response.data && response.data.yearList;
    let issueList = response.data && response.data.issueList;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_MATRIX_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_MATRIX_FULFILLED,
      payload: { data, yearList, issueList },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_MATRIX_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};